//Source: https://monetizenow.atlassian.net/browse/BP-14676

import { Maybe } from '@monetize/types/common';
import { arrayToObject } from '@monetize/utils/core';

export const OUTPUT_LANGUAGE_OPTIONS = [
  { title: 'Czech', value: 'cs_CZ' },
  { title: 'Danish', value: 'da_DK' },
  { title: 'Dutch', value: 'nl_NL' },
  { title: 'English (UK)', value: 'en_GB' },
  { title: 'English (US)', value: 'en_US' },
  { title: 'Finnish', value: 'fi_FI' },
  { title: 'French (Canada)', value: 'fr_CA' },
  { title: 'French', value: 'fr_FR' },
  { title: 'German', value: 'de_DE' },
  { title: 'Hungarian', value: 'hu_HU' },
  { title: 'Italian', value: 'it_IT' },
  { title: 'Norwegian', value: 'nb_NO' },
  { title: 'Polish', value: 'pl_PL' },
  { title: 'Portuguese (Brazil)', value: 'pt_BR' },
  { title: 'Portuguese (Portugal)', value: 'pt_PT' },
  { title: 'Romanian', value: 'ro_RO' },
  { title: 'Spanish (Latin America)', value: 'es_419' },
  { title: 'Spanish', value: 'es_ES' },
  { title: 'Swedish', value: 'sv_SE' },
];

// Lookup map for O(1) access to language titles by value
export const OUTPUT_LANGUAGE_MAP = arrayToObject(
  OUTPUT_LANGUAGE_OPTIONS,
  'value',
);

export const getLanguageLabel = (value: Maybe<string>) => {
  if (!value) {
    return null;
  }
  return OUTPUT_LANGUAGE_MAP[value]?.title || value;
};
